import { Container, Section, Eyebrow } from '@/components/primitives/Container';

const TIMELINE = [
  {
    year: '1869',
    title: 'Fundación de Editorial Estrada',
    body: 'Ángel Estrada funda la editorial en Buenos Aires. Su misión, desde el inicio, es producir soportes para la educación argentina.',
  },
  {
    year: 'Siglo XX',
    title: 'Manuales y libros escolares',
    body: 'Estrada acompaña cada cambio del sistema educativo argentino con manuales, libros de lectura y material complementario.',
  },
  {
    year: 'Hoy',
    title: 'SICA',
    body: 'El rol del editor educativo argentino se extiende: ya no alcanza con producir el documento. Hace falta hacerlo legible y citable.',
  },
];

export function Sobre() {
  return (
    <>
      <Section className="pt-12 sm:pt-16">
        <Container width="editorial">
          <Eyebrow>Sobre SICA</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl font-normal tracking-tight sm:text-5xl">
            Estrada lleva más de 150 años construyendo soportes para que la escuela argentina
            funcione. SICA es el siguiente.
          </h1>
        </Container>
      </Section>

      <Section ariaLabelledby="origen-title" className="pt-0">
        <Container width="editorial">
          <Eyebrow>Origen y misión</Eyebrow>
          <h2 id="origen-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            La editorial educativa argentina más longeva, ahora también en infraestructura
            curricular.
          </h2>
          <ol className="mt-10 flex flex-col gap-6">
            {TIMELINE.map((item) => (
              <li key={item.year} className="grid gap-2 border-l-2 border-line pl-5 sm:grid-cols-[8rem_1fr] sm:gap-6">
                <p className="text-xs font-semibold uppercase tracking-wider text-accent sm:pt-1">
                  {item.year}
                </p>
                <div>
                  <h3 className="font-serif text-lg font-normal tracking-tight text-ink">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-base leading-relaxed text-ink-muted">{item.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </Container>
      </Section>

      <Section ariaLabelledby="ahora-title" className="bg-paper-tinted/40">
        <Container width="editorial">
          <Eyebrow>Por qué ahora</Eyebrow>
          <h2 id="ahora-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            El sistema federal se volvió ilegible en su escala actual. La inteligencia curricular
            hace falta.
          </h2>
          <p className="prose-editorial mt-6">
            El federalismo educativo argentino genera, por diseño, un piso común (NAP) y autonomía
            jurisdiccional. Hoy un docente, un directivo o un especialista enfrenta esa convivencia
            como fragmentación: 24 diseños jurisdiccionales, NAP nacionales, ciclos y modalidades
            cruzados, y ningún sistema que muestre la jerarquía federal de un vistazo. SICA atiende
            ese hueco — sin reemplazar a nadie.
          </p>
        </Container>
      </Section>

      <Section ariaLabelledby="estrada-title">
        <Container width="editorial">
          <Eyebrow>Por qué Estrada</Eyebrow>
          <h2 id="estrada-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Hace 150 años que cuidamos cómo la norma llega al aula.
          </h2>
          <p className="prose-editorial mt-6">
            Estrada tiene estándar editorial heredado de más de un siglo y medio de práctica:
            política de fuentes, gobernanza editorial, presencia en los tres niveles obligatorios.
            Esa práctica es la que sostiene la promesa central de SICA: cita exacta, cero
            alucinaciones, jerarquía preservada.
          </p>
        </Container>
      </Section>
    </>
  );
}
